import { render, staticRenderFns } from "./AggregateOrders.vue?vue&type=template&id=94608c04&scoped=true"
import script from "./AggregateOrders.vue?vue&type=script&lang=js"
export * from "./AggregateOrders.vue?vue&type=script&lang=js"
import style0 from "./AggregateOrders.vue?vue&type=style&index=0&id=94608c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94608c04",
  null
  
)

export default component.exports